import type { ReactNode } from 'react';
import { useWatch } from 'react-hook-form';

import { Fields, SecretType } from '../../../constants';
import type { SecretFormValues } from '../../../schemas';
import { ApiCredentialsFields } from '../ApiCredentialsFields';
import { DatabaseCredentialsFields } from '../DatabaseCredentialsFields';
import { PasswordFields } from '../PasswordFields';
import { PaymentCardFields } from '../PaymentCardFields';
import { SecureNoteFields } from '../SecureNoteFields';
import { SshKeyFields } from '../SshKeyFields';

const fieldsByType = {
    [SecretType.Password]: <PasswordFields />,
    [SecretType.PaymentCard]: <PaymentCardFields />,
    [SecretType.ApiCredentials]: <ApiCredentialsFields />,
    [SecretType.DatabaseCredentials]: <DatabaseCredentialsFields />,
    [SecretType.SshKey]: <SshKeyFields />,
    [SecretType.SecureNote]: <SecureNoteFields />,
} satisfies Record<SecretType, ReactNode>;

export const MainInformationFields = () => {
    const secretType = useWatch<SecretFormValues, Fields.TYPE>({ name: Fields.TYPE });

    return fieldsByType[secretType];
};
